<template>
	<div>
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getPaymentMerchantInfoUrl" @listData='getDeviceData'></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/MerchantForm.vue';
	import infoModal from './Template/MerchantModal.vue';
	import webapi from '../../../webapi.js';
	export default {
		components: {
			searchForm,
			infoModal
		},
		data() {
			return {
				getPaymentMerchantInfoUrl: webapi.base_api_url + '/Archives/GetPaymentMerchantInfo',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['档案管理', '>>', '商户管理'],
				//table标题数据
				columns1: [
					//Table普通实例
					{
						title: '关联运营商',
						key: 'OperatorId',
						minWidth: 120,
						render: (h, params) => {
							return h('div', params.row.OperatorName)
						}
					},
					//Table列表实例
					{
						title: '商户类型',
						key: 'MchType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.MchTypeDesc)
						}
					}, {
						title: '商户名称',
						key: 'Name',
						minWidth: 120,
					}, {
						title: 'appId',
						key: 'AppId',
						minWidth: 100,
					}, {
						title: '商户号',
						key: 'MchId',
						minWidth: 100,
					}, {
						title: '子商户号',
						key: 'SubMchId',
						minWidth: 100,
					}, {
						title: '商户密钥',
						key: 'MchKey',
						minWidth: 150,
						render: (h, params) => {
							let key = params.row.MchKey
							if (!key) return h('div', '');
							let len = key.length - 3 - 3;
							if (len <= 0) return h('div', '******');
							// let xing = "";
							// for (let i = 0; i < len; i++) {
							// 	xing += '*';
							// }
							key = key.substring(0, 3) + "***" + key.substring(key.length - 3)
							return h('div', key)
						}
					}, {
						title: '证书路径',
						key: 'CertFile',
						minWidth: 200
					}, {
						title: '证书密码',
						key: 'CertPwd',
						minWidth: 100,
						render: (h, params) => {
							let key = params.row.CertPwd
							if (!key) return h('div', '');
							let len = key.length - 3 - 3;
							if (len <= 0) return h('div', '******');
							// let xing = "";
							// for (let i = 0; i < len; i++) {
							// 	xing += '*';
							// }
							key = key.substring(0, 3) + "***" + key.substring(key.length - 3)
							return h('div', key)
						}
					}, {
						title: '签名算法',
						key: 'SignType',
						minWidth: 100,
					}, {
						title: '支付结果通知',
						key: 'PayNotifyUrl',
						minWidth: 200
					}, {
						title: '操作',
						key: 'action',
						align: 'center',
						minWidth: 160,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('view', params.row)
										}
									}
								}, '查看') : h(),
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up', params.row)
										}
									}
								}, '修改') : h(),
							]);
						}
					}
				],
				data: [],
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//删除修改之外的其他操作
			otherMethod: function(Id) {
				this.$axios.post(webapi.base_api_url + "/Archives/PushEvent", {
					Id: Id,
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info('事件Id' + Id + '推送成功');
						this.handleSubmit();
					}
				})
			},
			/******************组件固定方法*************************/
			show: function(type, params) {
				this.$refs.ItemModal.show(type, params)
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
